<template>
  <v-dialog
    v-model="visible"
    width="500"
    persistent
  >
    <v-card>
      <v-card-title
        class="justify-center text-h6 text-center"
        :class="error ? 'red--text': 'secondary--text'"
      >
        {{ title }}
      </v-card-title>
      <v-card-text
        v-if="text"
        class="text-h5 text-center"
        :class="{ 'success--text': success }"
      >
        {{ text }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="close"
        >
          ОК
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ResultModal',
  props: {
    value: Boolean,
    title: String,
    text: String,
    success: Boolean,
    error: Boolean,
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>
